const styles = (theme) => ({
  infoBanner: {
    'backgroundColor': theme.palette.common.swatch[200],
    'color': '#131619',
    '& > .bannerIcon': {
      color: '#6E7680',
    },
  },
  warningBanner: {
    'backgroundColor': '#FFF9F2',
    'color': '#361E00',
    '& > .bannerIcon': {
      color: '#B36200',
    },
  },
  errorBanner: {
    'backgroundColor': '#FFF2F5',
    'color': '#44010D',
    '& > .bannerIcon': {
      color: '#E8173D',
    },
  },
  successBanner: {
    'backgroundColor': '#F2FFF6',
    'color': '#022B0F',
    '& > .bannerIcon': {
      color: '#268543',
    },
  },
  bannerIcon: {
    marginRight: '10px',
  },
});

export const bannerBoxStyles = (theme) => ({
  root: {
    padding: '12px 16px',
    margin: 0,
    boxSizing: 'border-box',
    borderRadius: '8px',
    minWidth: 'min-content',
    overflow: 'hidden',
    opacity: 1,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    transition: 'opacity .2s',
  },
});

export default styles;
